<template>
  <div>
      <the-header @change-active-menu="handleActiveSidebar()"/>
      <the-aside :activeSidebarMenu="activeSidebarMenu" @change-active-menu="handleActiveSidebar()" />
      <div class="container-fluid pt-5">
        <router-view style="min-height: 80vh !important;"></router-view>
      </div>
      <the-fooder/>

  </div>
</template>
<script>
import TheHeader from '@/layout/header/TheHeader.vue';
import TheAside from '@/layout/sidebar/TheAside.vue'
import TheFooder from '@/layout/footer/TheFooter.vue'
export default {
    name:'MainContainer',
    components:{TheHeader,TheAside,TheFooder},
    data(){
        return{
          activeSidebarMenu: false
        }
    },
    methods:{
      handleActiveSidebar(){
        this.activeSidebarMenu = ! this.activeSidebarMenu
      }
    }
}
</script>
